export default "__VITE_ASSET__B19w68lP__"